import {
  FilterTypeSelection,
  MODEL_FILTER_TYPES,
  ModelFilterType,
} from 'dashboard409a/components/ModelsTable/ModelsTable.types';

export const DEFAULT_FILTER_TYPE_SELECTION: FilterTypeSelection = {
  assigned: true,
  unassigned: false,
  all: false,
};

/**
 * Maps legacy saved filterType strings (and unknown values) to the current contract.
 */
export function normalizeModelFilterType(filterType: string | undefined | null): ModelFilterType {
  if (!filterType) {
    return MODEL_FILTER_TYPES.ASSIGNED;
  }
  if (filterType === MODEL_FILTER_TYPES.UNASSIGNED) {
    return MODEL_FILTER_TYPES.UNASSIGNED;
  }
  if (filterType === MODEL_FILTER_TYPES.ALL) {
    return MODEL_FILTER_TYPES.ALL;
  }
  if (filterType === MODEL_FILTER_TYPES.ASSIGNED) {
    return MODEL_FILTER_TYPES.ASSIGNED;
  }
  if (filterType === 'current' || filterType === 'past') {
    return MODEL_FILTER_TYPES.ASSIGNED;
  }
  return MODEL_FILTER_TYPES.ASSIGNED;
}

/**
 * Normalizes filterTypeSelection from localStorage or API, including legacy { current, past, ... } objects.
 */
export function normalizeFilterTypeSelection(
  selection: FilterTypeSelection | Record<string, unknown> | undefined | null,
  filterTypeFallback?: string | null
): FilterTypeSelection {
  if (selection && typeof selection === 'object') {
    const s = selection as Record<string, unknown>;
    if ('assigned' in s && typeof s.assigned === 'boolean') {
      return {
        assigned: Boolean(s.assigned),
        unassigned: Boolean(s.unassigned),
        all: Boolean(s.all),
      };
    }
    if ('current' in s || 'past' in s) {
      const current = Boolean(s.current);
      const past = Boolean(s.past);
      const unassigned = Boolean(s.unassigned);
      const legacyAll = Boolean(s.all);
      if (legacyAll) {
        return { assigned: true, unassigned: true, all: true };
      }
      const assignedSegment = current || past;
      return {
        assigned: assignedSegment,
        unassigned,
        all: assignedSegment && unassigned,
      };
    }
  }

  const ft = normalizeModelFilterType(filterTypeFallback ?? undefined);
  switch (ft) {
    case MODEL_FILTER_TYPES.UNASSIGNED:
      return { assigned: false, unassigned: true, all: false };
    case MODEL_FILTER_TYPES.ALL:
      return { assigned: true, unassigned: true, all: true };
    default:
      return { assigned: true, unassigned: false, all: false };
  }
}
